import React from 'react';
import {
  Link as RouterLink,
  NavLink as RouterNavLink,
  Navigate as RouterNavigate,
  useNavigate as useRouterNavigate,
  useLocation,
} from 'react-router-dom';

function appendSearch(to, search) {
  if (!search) return to;
  if (typeof to === 'string') {
    return to.includes('?') ? to : to + search;
  }
  if (typeof to === 'object' && !to.search) {
    return { ...to, search };
  }
  return to;
}

export const Link = React.forwardRef(function Link({ to, ...props }, ref) {
  const location = useLocation();
  return <RouterLink ref={ref} to={appendSearch(to, location.search)} {...props} />;
});

export const NavLink = React.forwardRef(function NavLink({ to, ...props }, ref) {
  const location = useLocation();
  return <RouterNavLink ref={ref} to={appendSearch(to, location.search)} {...props} />;
});

export function Navigate({ to, ...props }) {
  const location = useLocation();
  return <RouterNavigate to={appendSearch(to, location.search)} {...props} />;
}

export function useNavigate() {
  const nav = useRouterNavigate();
  const location = useLocation();
  return (to, options) => nav(appendSearch(to, location.search), options);
}
